import { render, staticRenderFns } from "./ProjectDocument.vue?vue&type=template&id=500af0d4&scoped=true"
import script from "./ProjectDocument.vue?vue&type=script&lang=js"
export * from "./ProjectDocument.vue?vue&type=script&lang=js"
import style0 from "./ProjectDocument.vue?vue&type=style&index=0&id=500af0d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500af0d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('500af0d4')) {
      api.createRecord('500af0d4', component.options)
    } else {
      api.reload('500af0d4', component.options)
    }
    module.hot.accept("./ProjectDocument.vue?vue&type=template&id=500af0d4&scoped=true", function () {
      api.rerender('500af0d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Before/ProjectInfo/ProjectDocument.vue"
export default component.exports